export default {
  url_to_save: process.env.VUE_APP_ENDPOINT_SAVE,
  url_to_search: process.env.VUE_APP_ENDPOINT_SEARCH,
  url_to_login: process.env.VUE_APP_ENDPOINT_LOGIN,
  url_to_logout: process.env.VUE_APP_ENDPOINT_LOGOUT,
  url_to_details: process.env.VUE_APP_ENDPOINT_DETAILS_APP,
  url_to_save_email: process.env.VUE_APP_ENDPOINT_SAVE_EMAIL,
  url_to_delete_app: process.env.VUE_APP_ENDPOINT_DELETE,
  url_to_report_app: process.env.VUE_APP_ENDPOINT_REPORT,
  url_to_update_app: process.env.VUE_APP_ENDPOINT_UPDATE,
  url_to_profile:process.env.VUE_APP_ENDPOINT_PROFILE,
};
